import { render, staticRenderFns } from "./DateSummary.vue?vue&type=template&id=1b64de2a&scoped=true&"
import script from "./DateSummary.vue?vue&type=script&lang=js&"
export * from "./DateSummary.vue?vue&type=script&lang=js&"
import style0 from "./DateSummary.vue?vue&type=style&index=0&id=1b64de2a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b64de2a",
  null
  
)

export default component.exports